<template>
    <div class="container-fluid adminWeeducCreateFile page-card text-left">
        <div>
            <h3 class="page-title">Novo Arquivo</h3>
            <p class="page-subtitle">
                Crie atividades com arquivos para os alunos
            </p>
        </div>
        <hr class="page-card__divider mb-4 mb-md-5" />

        <div v-if="!isSaving">
            <div class="row">
                <div class="col-12 col-md-6 m-0">
                    <div class="mb-3 mb-md-4">
                        <label class="labeld required" for="fileTitleInput"
                            >Título</label
                        >
                        <input
                            type="text"
                            id="fileTitleInput"
                            class="inputd"
                            v-model="fileTitle"
                            placeholder="Escreva um nome que chame a atenção"
                            required
                        />
                    </div>
                    <div class="mb-3 mb-md-4">
                        <label class="labeld" for="description"
                            >Descrição</label
                        >
                        <textarea
                            id="description"
                            class="inputd"
                            v-model="fileDescription"
                            placeholder="Descreva sobre o arquivo"
                        ></textarea>
                    </div>
                    <div class="mb-3 mb-md-4">
                        <label class="labeld" for="file-upload">Arquivo</label>
                        <v-file-input
                            v-model="selectedFile"
                            id="fileInput"
                            accept=".pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            prependInnerIcon="mdi-paperclip"
                            :prepend-icon="false"
                            class="inputd"
                            variant="outlined"
                            density="compact"
                            @change="handleFileUpload"
                            hideDetails
                        ></v-file-input>
                        <small>Formatos aceitos: PDF | Limite de 10MB</small>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="preview-container" style="position: relative">
                        <Loader v-if="isLoading" />
                        <iframe
                            v-if="filePreview"
                            :src="filePreview"
                            class="preview-pdf"
                            frameborder="0"
                        ></iframe>
                        <div
                            class="preview-container-no-file"
                            v-if="!filePreview && !isLoading"
                        >
                            <div class="no-file-info">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="38"
                                    height="38"
                                    fill="#cccccc"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        d="M19.707 17.293l-3.387-3.387A6.948 6.948 0 0 0 17 10c0-3.86-3.14-7-7-7S3 6.14 3 10s3.14 7 7 7c1.61 0 3.09-.55 4.293-1.414l3.387 3.387a1 1 0 0 0 1.414-1.414zM5 10c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5z"
                                    />
                                </svg>
                                <p class="no-file-text">
                                    Nenhum arquivo PDF selecionado
                                </p>
                                <span class="no-file-tip"
                                    >Envie um arquivo PDF para visualizar a
                                    prévia.</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Loader v-else />
        <div class="button-container">
            <v-btn
                variant="tonal"
                color="grey"
                size="large"
                @click="$router.go(-1)"
            >
                Cancelar
            </v-btn>
            <v-btn
                variant="flat"
                color="primary"
                size="large"
                @click="saveFile"
            >
                Salvar
            </v-btn>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { toast } from 'vue3-toastify';
    import apiLesson from '@/utils/lesson';
    import apiAWS from '@/utils/storage/aws';
    import Loader from '@/components/Loader/loader.vue';

    export default {
        components: {
            Loader,
        },
        data() {
            return {
                fileTitle: '',
                fileDescription: '',
                filePreview: null,
                selectedFile: null,
                link: null,
                isLoading: false,
                isSaving: false,
            };
        },
        computed: {
            ...mapState(['token', 'currentCollections', 'currentModule']),
        },
        methods: {
            async putFileAws(url, file) {
                try {
                    const response = await apiAWS.putFileAWS(url, file);
                } catch (error) {
                    console.error('Erro ao enviar arquivo para AWS');
                }
            },
            async handleFileUpload(event) {
                this.isLoading = true;
                try {
                    const file = event.target.files[0];
                    const response = await apiAWS.getSignaturePdf(
                        this.token,
                        file.name
                    );
                    await this.putFileAws(response.url, file);
                    this.link = response.token;
                    this.selectedFile = file;
                    this.filePreview = URL.createObjectURL(file);
                } catch (error) {
                    toast.error('Erro na geração do TOKEN AWS');
                    console.error('Erro na geração do TOKEN AWS');
                } finally {
                    this.isLoading = false;
                }
            },
            cancel() {
                this.fileTitle = '';
                this.fileDescription = '';
                this.filePreview = null;
                this.selectedFile = null;
            },
            async saveFile() {
                const payload = {
                    type: 4,
                    title: this.fileTitle,
                    path: this.link,
                    description: this.fileDescription,
                    idQuiz: null,
                    idModule: this.currentModule.id,
                    idCourse: this.currentCollections.id,
                    status: 1,
                };
                try {
                    this.isSaving = true;
                    const response = await apiLesson.createNewLesson(
                        payload,
                        this.token
                    );
                    this.$router.push({
                        path: '/dashboard/curso',
                        query: { toast: 'Arquivo salvo com sucesso!' },
                    });
                } catch (error) {
                    toast.error('Erro ao criar aula');
                    console.error('Erro ao criar aula');
                } finally {
                    this.isSaving = false;
                }
            },
        },
    };
</script>

<style scoped>
    .no-file-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 223px;
        background: rgb(var(--v-theme-fieldBackground));
        border: 1px dashed #cccccc;
        border-radius: 8px;
        margin-top: 42px;
        margin-bottom: 20px;
        padding: 24px 10px;
        text-align: center;
    }
    .no-file-info svg {
        margin-bottom: 10px;
    }
    .no-file-text {
        font-size: 17px;
        color: #888;
        font-weight: 600;
        margin-bottom: 4px;
    }
    .no-file-tip {
        font-size: 13px;
        color: #aaa;
    }
    .preview-pdf {
        width: 100%;
        height: 70vh;
        border: none;
    }
</style>
